import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { testimonials, testimonialsCopy } from '../data/content';
export function Testimonials() {
  return <Section tone="tint" eyebrow={testimonialsCopy.eyebrow} title={testimonialsCopy.title} width="narrow" data-id="element-253" data-mp="3fz5sgaaeu6ml">
      <ul className="mx-auto max-w-4xl divide-y divide-blue-200/70" data-id="element-254" data-mp="3b01ez7ggdmqg">
        {testimonials.map(item => <li key={item.author} className="grid gap-4 py-7 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,15rem)_1fr] md:gap-10" data-id="element-255" data-mp="370akasnt2mgn">
            <div className="flex items-start gap-3" data-id="element-256" data-mp="2x1uqghxe8z3g">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-bold text-white" data-id="element-257" data-mp="2x2ml9qj62sso">
                {item.initials}
              </span>
              <span data-id="element-258" data-mp="v7c6l6gih5pe">
                <span className="flex gap-0.5" aria-label={testimonialsCopy.starsLabel} data-id="element-259" data-mp="qaljhz6ah9uh">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-blue-500 text-blue-500" aria-hidden="true" data-id="element-260" data-mp="h4n3qbjitzax" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-extrabold tracking-tight text-slate-900" data-id="element-261" data-mp="c6llfstx640i">
                  {item.author}
                </span>
                <span className="block text-sm text-blue-900/70" data-id="element-262" data-mp="zxr38djf76dg">{item.role}</span>
                {item.city && <span className="inline-flex items-center gap-1 text-sm text-blue-900/60" data-id="element-263" data-mp="14ur50c98lmyr">
                    <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-264" data-mp="q6cv5hdeky8p" />
                    {item.city}
                  </span>}
              </span>
            </div>
            <blockquote className="text-lg italic leading-relaxed text-slate-900 md:text-xl" data-id="element-265" data-mp="1itqvlpgb8bxk">
              “{item.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}